import { createI18n } from "vue-i18n"
import messages from "./messages.json"

type SupportedLanguage = keyof typeof messages

const SUPPORTED_LANGUAGES = Object.keys(messages) as SupportedLanguage[]
const DEFAULT_LANGUAGE: SupportedLanguage = "fr"

export function isSupportedLanguage(lang: string): lang is SupportedLanguage {
	return (SUPPORTED_LANGUAGES as string[]).includes(lang)
}

const getLocaleFromParam = () => {
	const params = new URLSearchParams(window.location.search)
	return params.has("lang") ? params.get("lang") : null
}

const getLocaleFromStorage = () => {
	return window.localStorage?.getItem("lang") ?? null
}

const getLocaleFromNavigator = () => {
	const browserLang = navigator.language
	return browserLang ? browserLang.substring(0, 2) : null
}

const getDefaultLocale = (): SupportedLanguage => {
	const lang = getLocaleFromParam() || getLocaleFromStorage() || getLocaleFromNavigator()
	return lang && isSupportedLanguage(lang) ? lang : DEFAULT_LANGUAGE
}

export const updatePageMetaInfo = (title: string, description: string) => {
	document.title = title
	const metaDesc = document.querySelector('meta[name="description"]')
	if (metaDesc) {
		metaDesc.setAttribute("content", description)
	}
}

export function setAppLanguage(lang: string): void {
	if (!isSupportedLanguage(lang)) {
		console.warn(`Unsupported language ${lang}`)
		return
	}
	i18n.global.locale.value = lang
}

const i18n = createI18n({
	allowComposition: true,
	legacy: false,
	locale: getDefaultLocale(),
	fallbackLocale: DEFAULT_LANGUAGE,
	messages,
})

export function translateToEnglish(translationKey: string): string {
	return i18n.global.t(translationKey, {}, { locale: "en" })
}

export function translatedSelectOption<Value>(value: Value, translationKey: string) {
	return {
		value,
		label: i18n.global.t(translationKey),
	}
}

updatePageMetaInfo(String(i18n.global.t("meta-title")), String(i18n.global.t("meta-description")))

export default i18n
